import type { CatalogueEntry } from "../types";
import imageLight from "../images/abs-boundaries.light.webp";
import imageDark from "../images/abs-boundaries.dark.webp";

export const entry: CatalogueEntry = {
  slug: "abs-boundaries",
  // Renamed for the Hub only, superseded by ABS ASGS Main Structure. The slug and product
  // code are unchanged so existing URLs and the datasets API keep working.
  displayName: `ABS Boundaries (Legacy)`,
  datasetProductCode: `ABS BOUNDARIES`,
  subtitle: `Integrating Australian Statistical Geography Standard Boundaries.`,
  shortDescription: `ABS Boundaries is a digital representation of Australian Statistical Geography Standard (ASGS) boundaries produced by the Australian Bureau of Statistics (ABS). The ASGS brings all the regions for which the ABS publishes statistics within the one framework and is used by the ABS for the collection and dissemination of geographically classified statistics since 1 July 2011. The ABS release a new version of their boundaries for each Census and the two latest versions are included in Geoscape Australia's ABS Boundaries product. The Mesh Blocks released are used in building all ASGS boundaries. SEIFA is not a boundary dataset, but provides socio-economic indexes for the ABS statistical areas.
The ABS Boundaries dataset is comprised of two themes:
-	Australian Bureau of Statistics (ABS) Boundaries 2016
-	Australian Bureau of Statistics (ABS) Boundaries 2021
The ABS Boundaries 2016 theme includes five layers:
-	2016 ABS Mesh Blocks and Statistical Areas
-	2016 ABS Indigenous Regions, Areas and Locations
-	2016 Urban Centre and Locality - Section of State - Significant Urban Area
-	2016 Remoteness Area (RA)
-	2016 SEIFA (Socio-Economic Indexes for Areas)
The ABS Boundaries 2021 theme includes five layers:
-	2021 ABS Mesh Blocks and Statistical Areas
-	2021 ABS Indigenous Regions, Areas and Locations
-	2021 Urban Centre and Locality - Section of State - Significant Urban Area
-	2021 Remoteness Area (RA)
-	2021 SEIFA (Socio-Economic Indexes for Areas)`,
  metadata: {
    dateAdded: 1630368000000,
    dataType: ["Polygons"],
    theme: `Statistical Boundaries`,
    totalFeatureCount: 526594,
    updateFrequency: `Quarterly`,
    license: `CC BY 4.0`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/en/stable/abs_boundaries.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/en/stable/abs_boundaries.html`,
  imageLight,
  imageDark,
  searchTags: `ABS Boundaries Areas Census Census Mapping Demographic Study Economic Advantages Economic Disadvantages Geographic Analysis Socio-Economic Indexes Statistical Reporting Stats`,
  detail: () => import("../details/abs-boundaries").then((m) => m.detail),
};

export default entry;
